import React from 'react';
import './ValuesPage.css';

function ValuesPage() {
  return (
    <div className="container-fluid">
      <div className="value text-center">
        <div className="hero_about_text mx-auto">
          <h1>Our Values</h1>
        </div>
        <div className="about_value text-center">
          <p className="mx-auto">Welcome to DharManager, where we are passionate about revolutionizing the world of HR solutions.
            With 10 years of experience and expertise, we are dedicated to providing seamless recruitment and onboarding experiences for businesses of all sizes</p>
        </div>
        <div className="value_text text-center">
          <div className="vtext mx-auto">
            <h1>Payroll Management</h1>
            <p>Effortless Payroll Management</p>
          </div>
          <div className="vtext mx-auto">
            <p>Managing payroll can be a daunting task, but at DharManager, we simplify it for you. Our Payroll Management system is designed to handle everything from salary calculations to tax deductions with accuracy and efficiency.</p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-9">
              <div className=" d-flex text-center">
                <div className="b_how benefits me-5">
                  <h1 className='text-center'>Benefits</h1>
                  <ul>
                    <li>Accuracy: Automated calculations reduce errors and ensure timely payments.</li>
                    <li>Compliance: Stay compliant with local and international payroll regulations.</li>
                    <li>Efficiency: Save time and reduce administrative burden with automated processes.</li>
                    <li>Employee Satisfaction: Ensure employees are paid correctly and on time, boosting morale and trust.</li>
                  </ul>
                </div>
                <div className="b_how benefits text-center align">
                  <h1>How It Aligns with Our Mission</h1>
                  <p>Our Payroll Management service is a testament to our commitment to making HR processes seamless and efficient. By automating payroll, we help organizations focus on their core activities, driving growth and success.</p>
                  <a id="contact" className="btn btn-primary mt-auto">Contact for demo</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="value_text text-center">
          <div className="vtext mx-auto">
            <h1>Employee Database</h1>
            <p>Comprehensive Employee Database</p>
          </div>
          <div className="vtext mx-auto">
            <p>Keep all your employee information in one secure place with our Employee Database. This central repository allows for easy access and management of employee records.</p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-9">
            <div className=" d-flex text-center">
              <div className="b_how benefits me-5">
                  <h1 className='text-center'>Benefits</h1>
                  <ul>
                    <li>Centralized Information: Store all employee data in a single, secure location.</li>
                    <li>Accessibility: Access employee records from anywhere at any time.</li>
                    <li>Data Integrity: Maintain up-to-date and accurate employee information.</li>
                    <li>Scalability: Easily scale as your organization grows without losing track of vital data.</li>
                  </ul>
                </div>
                <div className="b_how benefits text-center align">
                  <h1>How It Aligns with Our Mission</h1>
                  <p>Our Employee Database underscores our vision of simplifying HR processes. By providing a centralized and accessible platform, we empower organizations to manage their workforce effectively, fostering a more organized and responsive HR environment</p>
                  <a id="contact" className="btn btn-primary mt-auto">Contact for demo</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="value_text text-center">
          <div className="vtext mx-auto">
            <h1>Training and Development</h1>
            <p>Empower Your Workforce with Training and Development</p>
          </div>
          <div className="vtext mx-auto">
            <p>Invest in your employees' growth with our Training and Development programs. We offer customized training solutions to help your team acquire new skills and enhance their performance.</p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-9">
            <div className=" d-flex text-center">
              <div className="b_how benefits me-5">
                  <h1 className='text-center'>Benefits</h1>
                  <ul>
                    <li>Skill Enhancement: Equip your employees with the latest skills and knowledge.</li>
                    <li>Employee Engagement: Increase job satisfaction and retention through continuous learning opportunities.</li>
                    <li>Performance Improvement: Boost productivity and performance with targeted training.</li>
                    <li>Organizational Growth: Drive your company’s growth by developing a highly skilled workforce.</li>
                  </ul>
                </div>
                <div className="b_how benefits text-center align">
                  <h1>How It Aligns with Our Mission</h1>
                  <p>Our Training and Development service reflects our dedication to fostering employee growth and development. By investing in your team’s skills, we help you build a capable and motivated workforce, driving organizational success and innovation.</p>
                  <a id="contact" className="btn btn-primary mt-auto">Contact for demo</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ValuesPage;